"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deviceLogin = deviceLogin;
exports.deviceLoginSucceeded = deviceLoginSucceeded;
exports.deviceLoginFailed = deviceLoginFailed;
var DEVICE_LOGIN_REQUESTED = 'DEVICE_LOGIN_REQUESTED';
var DEVICE_LOGIN_SUCCEEDED = 'DEVICE_LOGIN_SUCCEEDED';
var DEVICE_LOGIN_FAILED = 'DEVICE_LOGIN_FAILED';

function deviceLogin(deviceId, appKey, organizationName) {
  return {
    type: DEVICE_LOGIN_REQUESTED,
    payload: {
      deviceId: deviceId,
      appKey: appKey,
      organizationName: organizationName
    }
  };
}

deviceLogin.type = DEVICE_LOGIN_REQUESTED;

function deviceLoginSucceeded(payload) {
  return {
    type: DEVICE_LOGIN_SUCCEEDED,
    payload: payload
  };
}

deviceLoginSucceeded.type = DEVICE_LOGIN_SUCCEEDED;

function deviceLoginFailed(payload) {
  return {
    type: DEVICE_LOGIN_FAILED,
    payload: payload
  };
}

deviceLoginFailed.type = DEVICE_LOGIN_FAILED;